import React from "react";
import styled from "@emotion/styled";
import { CSS_MQ } from "../../../../styles/breakpoints";

export const StyledList = styled.ul`
  display: flex;
  flex-wrap: wrap;

  &:not(.gridless) {
    display: grid;

    &.one {
      grid-template-columns: repeat(1, minmax(0, 1fr));
    }

    &.two {
      grid-template-columns: repeat(2, minmax(0, 1fr));
      grid-gap: 10px;
    }
  }

  --mb: 30px;
  ${CSS_MQ.atLeastSm} {
    --mb: 40px;
  }
  ${CSS_MQ.atLeastMd} {
    --mb: 50px;
  }

  &.has-children {
    --mb: 20px;
    ${CSS_MQ.atLeastMd} {
      --mb: 25px;
    }
  }

  &.one-per-line {
    grid-gap: 10px;
    gap: 10px;
  }

  &.more-gap {
    gap: 20px;

    ${CSS_MQ.atLeastMd} {
      gap: 32px;
    }
  }

  margin-bottom: var(--mb);
`;
export const StyledListElement = styled.li`
  &.enabled,
  &.active {
    cursor: pointer;
  }

  &.disabled {
    cursor: not-allowed;
  }
`;
